import { apiClient } from './apiClient';

export interface AppointmentRequest {
  id: string;
  description?: string;
  serviceId?: string;
  doctorId?: string;
  success: boolean;
  createdAt: string;
}

export interface PaperRequest {
  id: string;
  paperType?: string;
  comment?: string;
  processed: boolean;
  createdAt: string;
}

export interface CertificateRequest {
  id: string;
  certificateType?: string;
  description?: string;
  processed: boolean;
  createdAt: string;
}

// Заявки на запись
export const getAppointmentRequests = (activeOnly?: boolean) =>
  apiClient.get<{ requests: AppointmentRequest[] }>(
    `/webapp/appointment-requests${activeOnly ? '?active=true' : ''}`
  );

export const createAppointmentRequest = (data: {
  description?: string;
  serviceId?: string;
  doctorId?: string;
  promoId?: string;
  from?: string;
}) =>
  apiClient.post<{ request: AppointmentRequest }>('/webapp/appointment-requests', data);

// Справки
export const getPaperRequests = (activeOnly?: boolean) =>
  apiClient.get<{ requests: PaperRequest[] }>(
    `/webapp/paper-requests${activeOnly ? '?active=true' : ''}`
  );

export const createPaperRequest = (data: { paperType?: string; comment?: string }) =>
  apiClient.post<{ request: PaperRequest }>('/webapp/paper-requests', data);

// Сертификаты
export const getCertificateRequests = (activeOnly?: boolean) =>
  apiClient.get<{ requests: CertificateRequest[] }>(
    `/webapp/certificate-requests${activeOnly ? '?active=true' : ''}`
  );

export const createCertificateRequest = (data: { certificateType?: string; description?: string }) =>
  apiClient.post<{ request: CertificateRequest }>('/webapp/certificate-requests', data);

// Запрос контакта менеджера для документов
export const createManagerContactRequest = (data?: { from?: string }) =>
  apiClient.post<{ success: boolean; message: string }>('/webapp/documents/manager-contact', data || { from: 'webapp' });

